import NextLink from 'next/link'
import { ComponentProps } from 'react'
import { Anchor, Typography } from 'ui/typography'
import { sprinkles, Sprinkles } from '../../theme/sprinkles.css'
import classNames from 'classnames'

export const Link: React.FC<Omit<React.ComponentProps<typeof Anchor>, 'href'> & React.ComponentProps<typeof NextLink>> &
	Omit<ComponentProps<typeof Typography>, 'component'> = ({ textDecoration, color, ...props }) => {
	const sprinklesProps: Sprinkles = {
		textDecoration: textDecoration || { default: 'none', hover: 'underline' },
		color: color || { default: 'primary.main' }
	}

	return (
		<NextLink href={props.href} passHref legacyBehavior>
			<Anchor {...props} className={classNames(sprinkles(sprinklesProps))} {...props}>
				{props.children}
			</Anchor>
		</NextLink>
	)
}
